export const STAGES = ["New", "Contacted", "Site Visit Scheduled", "Site Visit Done", "Negotiation", "Closed Won", "Closed Lost"];
export const TEMPS = ["HOT", "WARM", "COLD"];
export const LEAD_TYPES = ["Buyer", "Seller", "Tenant", "Landlord", "Investor"];
export const SOURCES = ["Walk-in", "Referral", "99acres", "MagicBricks", "Housing.com", "Facebook/Instagram", "Website", "Builder tie-up", "Other"];
export const PROPERTY_TYPES = ["Plot", "Flat", "Villa/Independent House", "Builder Floor", "Commercial Shop", "Office", "SCO", "Land", "Warehouse"];
export const LISTING_TYPES = ["Sale", "Rent", "Purchase requirement"];
export const PROP_STATUSES = ["Available", "On Hold", "Sold", "Rented", "Withdrawn"];
export const AREA_UNITS = ["sq ft", "sq yd", "acre"];
export const UNIT_TO_SQFT = { "sq ft": 1, "sq yd": 9, acre: 43560 };
export const BHK_OPTIONS = ["1 BHK", "2 BHK", "3 BHK", "4 BHK", "5 BHK", "6+ BHK"];
export const FACINGS = ["North", "South", "East", "West", "North-East", "North-West", "South-East", "South-West", "Main road", "Park facing"];
export const FOLLOWUP_TYPES = ["Call", "Visit", "WhatsApp", "Note"];
export const ROLE_LABEL = { admin: "Admin", partner: "Partner", accounts: "Accounts", employee: "Employee" };

const ACCESS = {
  leads: ["admin", "partner", "employee"],
  properties: ["admin", "partner", "employee"],
  users: ["admin", "partner"],
  activity: ["admin"],
  chat: ["admin", "partner"],
  tasks: ["admin", "partner", "employee"],
  finance: ["admin", "partner", "accounts"],
};
export const canEditFinance = (u) => ["admin", "partner"].includes(u?.role);
export const TASK_STATUSES = ["To Do", "In Progress", "Done"];
export const PRIORITIES = ["High", "Medium", "Low"];
export const PRIORITY_STYLE = {
  High: "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/50 dark:text-red-300 dark:border-red-900",
  Medium: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/50 dark:text-amber-300 dark:border-amber-900",
  Low: "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
};
export const isManager = (u) => ["admin", "partner"].includes(u?.role);
export const can = (user, m) => !!user && ACCESS[m].includes(user.role);
export const canDelete = (user) => ["admin", "partner"].includes(user?.role);
export const canSeeOwner = canDelete;
export const isAdmin = (user) => user?.role === "admin";

export const TEMP_STYLE = {
  HOT: "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/50 dark:text-red-300 dark:border-red-900",
  WARM: "bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-950/50 dark:text-orange-300 dark:border-orange-900",
  COLD: "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/50 dark:text-blue-300 dark:border-blue-900",
};
export const TEMP_HEX = { HOT: "#EF4444", WARM: "#F97316", COLD: "#3B82F6" };

export const STAGE_DOT = {
  New: "bg-slate-400",
  Contacted: "bg-sky-500",
  "Site Visit Scheduled": "bg-indigo-500",
  "Site Visit Done": "bg-cyan-600",
  Negotiation: "bg-amber-500",
  "Closed Won": "bg-emerald-500",
  "Closed Lost": "bg-rose-500",
};

export const STATUS_STYLE = {
  Available: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-900",
  "On Hold": "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-900",
  Sold: "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
  Rented: "bg-sky-50 text-sky-700 border-sky-200 dark:bg-sky-950/40 dark:text-sky-300 dark:border-sky-900",
  Withdrawn: "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-900",
};

export const telLink = (p) => `tel:+91${p}`;
export const waLink = (p, text = "") => `https://wa.me/91${p}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
